export default "__VITE_ASSET__oN628zs5__"